module.exports = __webpack_public_path__ + "media/images/icons/icon_twitter-b8388df33743b065ec6df16cf7d86c5a.svg";